import i18n from "src/i18n";

import { ROLES } from "@constants/index";

// todo: Move all nav links to "constants" directory since they won't change often

export const getAppointmentNavLinks = (canAccessPath: (path: string) => boolean, userRoles: string[]) => {
  const links = [
    {
      title: i18n.t("incoming"),
      link: "incoming",
      isEnabled: true, //* NB: Doctors with receptionist roles can see "incoming" page if they somehow get access to the URL
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST],
    },
    {
      title: i18n.t("schedule"),
      link: "schedule",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.NURSE],
    },
    {
      title: i18n.t("booked"),
      link: "booked",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.DOCTOR],
    },
    {
      title: i18n.t("follow-up"),
      link: "follow-up",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.NURSE],
    },
    {
      title: i18n.t("virtual-slots"),
      link: "slots",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.DOCTOR],
    },
    {
      title: i18n.t("slot-templates"),
      link: "slot-templates",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.DOCTOR],
    },
    {
      title: i18n.t("masterclass"),
      link: "masterclass",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.DOCTOR],
    },
  ];

  // Follow-up worklist is limited to scheduling staff; the other tabs follow permissions.
  const filteredLinks = links.filter(link => {
    return canAccessPath("appointments/" + link.link) &&
      (link.link !== "follow-up" || (
        link.roles.some(role => userRoles.includes(role)) &&
        (!userRoles.includes(ROLES.DOCTOR) || userRoles.includes(ROLES.ADMIN))
      ));
  });

  return filteredLinks;
};
